import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { Link } from '@tiptap/extension-link'
import { Image } from '@tiptap/extension-image'
import { Underline } from '@tiptap/extension-underline'
import { Highlight } from '@tiptap/extension-highlight'
import { TaskItem } from '@tiptap/extension-task-item'
import { TaskList } from '@tiptap/extension-task-list'

document.addEventListener('turbolinks:load', () => {
  const editorContentField = document.getElementById('editor-content-field');

  if(editorContentField == null) {
    return false;
  }

  const editor = new Editor({
    element: document.querySelector('.editor__content'),
    extensions: [
      StarterKit.configure(),
      Image.configure({
        inline: true,
      }),
      Link.configure(),
      Underline,
      Highlight,
      TaskItem,
      TaskList
    ],
    content: editorContentField.value ? editorContentField.value : '',
  })

  // Destroy the editor when the page is unloaded
  window.addEventListener('turbolinks:before-cache', () => {
    editor.destroy()
  })

  editor.on('update', () => {
    editorContentField.value = editor.getHTML();
  });

  const actions = {
    bold: () => editor.chain().focus().toggleBold().run(),
    italic: () => editor.chain().focus().toggleItalic().run(),
    strike: () => editor.chain().focus().toggleStrike().run(),
    code: () => editor.chain().focus().toggleCode().run(),
    highlight: () => editor.chain().focus().toggleHighlight().run(),
    // heading1: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
    // heading2: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
    // paragraph: () => editor.chain().focus().setParagraph().run(),
    bulletList: () => editor.chain().focus().toggleBulletList().run(),
    orderedList: () => editor.chain().focus().toggleOrderedList().run(),
    taskList: () => editor.chain().focus().toggleTaskList().run(),
    codeBlock: () => editor.chain().focus().toggleCodeBlock().run(),
    blockquote: () => editor.chain().focus().toggleBlockquote().run(),
    horizontalRule: () => editor.chain().focus().setHorizontalRule().run(),
    hardBreak: () => editor.chain().focus().setHardBreak().run(),
    clearFormat: () => editor.chain().focus().clearNodes().unsetAllMarks().run(),
    undo: () => editor.chain().focus().undo().run(),
    redo: () => editor.chain().focus().redo().run(),
    uploadImage: () => {
      // Create the file input
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.style.display = 'none'; // Hide the input field
      document.body.appendChild(input); // Append to the body temporarily to trigger the file dialog

      // Listen for changes on the input (i.e., when a file is selected)
      input.addEventListener('change', () => {
          const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
          let file = input.files[0];
          let formData = new FormData();

          formData.append('picture[picture]', file);

          fetch('/pictures/upload', {
              method: 'POST',
              headers: {
                  'X-CSRF-Token': csrfToken,
              },
              body: formData
          })
          .then(resp => resp.json())
          .then(data => {
              if (data.errors) {
                  alert(data.errors);
              } else {
                  // Insert the image into the editor
                  editor.chain().focus().setImage({ src: data.url }).run();

                  // Check if the hidden input for picture IDs already exists
                  let hiddenInput = document.querySelector("input[name='post[picture_ids][]']");

                  // If the hidden input exists, append the new ID to its value
                  if (hiddenInput) {
                      const existingIds = hiddenInput.value.split(',').map(id => parseInt(id, 10));
                      if (!existingIds.includes(data.id)) {
                          existingIds.push(data.id);
                          hiddenInput.value = existingIds.join(',');
                      }
                  } else {
                      // If the hidden input doesn't exist, create a new one and set its value to the new ID
                      hiddenInput = document.createElement('input');
                      hiddenInput.type = 'hidden';
                      hiddenInput.name = 'post[picture_ids][]';
                      hiddenInput.value = data.id;
                      document.querySelector('form').appendChild(hiddenInput);
                  }
              }
          })
          .catch(error => {
            console.error('Error uploading image:', error);
          });
      });

      // Trigger the file input
      input.click();
    }
  };

  function updateActiveButtons() {
    document.getElementById('bold').classList.toggle('active', editor.isActive('bold'));
    document.getElementById('italic').classList.toggle('active', editor.isActive('italic'));
    document.getElementById('strike').classList.toggle('active', editor.isActive('strike'));
    document.getElementById('code').classList.toggle('active', editor.isActive('code'));
    document.getElementById('highlight').classList.toggle('active', editor.isActive('highlight'));
    // document.getElementById('paragraph').classList.toggle('active', editor.isActive('paragraph'));
    document.getElementById('bulletList').classList.toggle('active', editor.isActive('bulletList'));
    document.getElementById('orderedList').classList.toggle('active', editor.isActive('orderedList'));
    document.getElementById('taskList').classList.toggle('active', editor.isActive('taskList'));
    document.getElementById('codeBlock').classList.toggle('active', editor.isActive('codeBlock'));
    document.getElementById('blockquote').classList.toggle('active', editor.isActive('blockquote'));
    document.getElementById('uploadImage').classList.toggle('active', editor.isActive('image'));
  }

  editor.on('selectionUpdate', () => {
    updateActiveButtons();
  });

  editor.on('update', () => {
    updateActiveButtons();
  });

  Object.keys(actions).forEach((id) => {
    document.getElementById(id).addEventListener('click', actions[id]);
  });

  document.getElementById('heading').addEventListener('change', (event) => {
    const level = event.target.value;
    if (level) {
      editor.chain().focus().toggleHeading({ level: parseInt(level) }).run();
    } else {
      editor.chain().focus().setParagraph().run();
    }
  });
  
})